// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CascadeDirection,
} from "./types";

export const params = {
  startTwinId: __t.string(),
  relationshipName: __t.string(),
  maxDepth: __t.u32(),
  get direction() {
    return CascadeDirection;
  },
};
export const returnType = __t.string()